'use client';

import { FC } from 'react';

import { Link } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { msgReplace } from '@telialt/utils/src/helpers';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';
import { useIsAuthorized } from '@telialt/utils/src/SSO/useIsAuthorized';

import { ESHOP_CATEGORY_TEST_ID } from '../../../constants/test-ids';
import { LoginCtaContainer, LoginCtaIcon } from './LoginCTA.styles';

const LOGIN_HREF = '/mano?source=i';

export const LoginCTA: FC = () => {
    const { t } = useTranslations();
    const isAuthenticated = useIsAuthorized();
    const segment = useSegment();

    if (isAuthenticated || segment === TeliaSegment.B2b) {
        return null;
    }

    return (
        <LoginCtaContainer data-test={ESHOP_CATEGORY_TEST_ID.CATEGORY_LOGIN_CTA}>
            <span>
                {msgReplace(t['eshop.category.login_cta.content'], {
                    loginLink: (_i, _tag, [text]) => (
                        <Link
                            key={text}
                            href={LOGIN_HREF}
                            variant="text"
                            data-test={ESHOP_CATEGORY_TEST_ID.CATEGORY_LOGIN_CTA_LINK}
                        >
                            {text}
                        </Link>
                    ),
                })}
            </span>
            <LoginCtaIcon />
        </LoginCtaContainer>
    );
};
